import { ensureArray } from '../index.js';
import { Observable } from './observable.js';

/**
 * Creates an Observable from a MutationObserver.
 *
 * @param target one or more nodes to observe
 * @param options optional MutationObserverInit object providing options to customize the observer.
 * @returns an Observable that emits MutationRecord[] objects.
 */
export const createMutationObservable = (target: Node | Node[], options?: MutationObserverInit) => new Observable<MutationRecord[]>(subscriber => {
    // create MutationObserver and emit mutations to the subsciber
    const observer = new MutationObserver(mutations => subscriber.next(mutations));
    // register nodes to observe
    ensureArray(target).forEach(node => observer.observe(node, options));
    // add teardown logic to disconnect the observer when the subscription is disposed
    subscriber.addTeardown(() => observer.disconnect());
});
